/**
 * header directive
 */
(function () {
	'use strict';
	angular
		.module('app')
		.directive('apHeader', ['authenticationSettings', function (authenticationSettings) {
			return {
				restrict: 'E',
				templateUrl: 'app/layout/header.html',
				scope: {},
				transclude: true,
				link: function (scope) {
					scope.logoUrl = authenticationSettings.dynamicContentUrl + '/1234/x/images/solera-autopoint_logo2019.svg';
				}
			};
		}]);
})();